// extracted by mini-css-extract-plugin
module.exports = {"form-input":"bind-card_form-input__U5PWM","hint":"bind-card_hint__17JHD"};